import { LoginContainer } from '@/features/auth';

export default function LoginPage() {
  return <LoginContainer />;
}
